<template>
  <div class="bgm" @click="bgmBtnClick">
    <div class="bgm-btn" :class="{rotate: bgmStatus}"><div class="mute" v-show="bgmStatus === false"></div></div>
  </div>
</template>

<script>
export default {
  name: 'BackgroundMusic',
  props: {
    src: String
  },
  data () {
    return {
      bgm: null,
      bgmStatus: 0 // 默认是不播放的状态，点击后还是播放，再次点击才是暂停
    }
  },
  mounted () {
    // console.log('bgm')
    if (window.$bgm) {
      // 如果this上绑定了bgm，就用这个
      this.bgm = window.$bgm
    } else {
      this.bgm = document.createElement('audio')
      this.bgm.src = this.src
      this.bgm.autoplay = 'true'
      this.bgm.loop = 'true'
      this.bgm.preload = 'true'
    }

    // 根据音频的播放状态，自动更新按钮状态
    this.bgm.addEventListener('play', () => {
      this.bgmStatus = true
    })
    this.bgm.addEventListener('pause', () => {
      this.bgmStatus = false
    })

    /// ///////////////////////////////////////////////////////////////////////////////////////////
    // if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'production') {
    //   // 开发环境下，保证音乐连续播放， 不因为自动更新而重头播放
    //   this.bgm.addEventListener('timeupdate', () => {
    //     localStorage['2020recall.bgmCur'] = this.bgm.currentTime
    //   })
    //   if (localStorage['2020recall.bgmCur']) {
    //     this.bgm.currentTime = Number(localStorage['2020recall.bgmCur'])
    //   }
    // }
    /// ///////////////////////////////////////////////////////////////////////////////////////////

    // 主动播放音频
    this.bgm.play()
    this.bgmStatus = !this.bgm.paused
  },
  methods: {
    bgmBtnClick () {
      // 点击开启、关闭背景音乐
      if (this.bgm.paused) {
        this.bgm.play()
      } else {
        this.bgm.pause()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.bgm{
  position: absolute;
  top: 0;
  right: 0;
  z-index: 50;
  padding: .5rem .6rem;
}
.bgm-btn {
  position: relative;
  border-radius: 50%;
  // width: 1.875rem;
  // height: 1.875rem;
  width: 1.4rem;
  height: 1.4rem;
  overflow: hidden;
  background-image: url(../assets/play.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .mute{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(../assets/pause.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;

    // position: absolute;
    // top: 50%;
    // left: 0;
    // width: 100%;
    // height: 2px;
    // background-color: rgba(69, 78, 142, .9);
    // transform: rotateZ(-45deg);
    // -webkit-transform: rotateZ(-45deg);
  }
}

.rotate{
  animation: rotate 3s linear infinite both;
  -webkit-animation: rotate 3s linear infinite both;
}
@keyframes rotate{
  0% {transform: rotate(0);}
  100% {transform: rotate(360deg);}
}
@-webkit-keyframes rotate{
  0% {-webkit-transform: rotate(0);}
  100% {-webkit-transform: rotate(360deg);}
}
</style>
